/**
 * GeChiUI dependencies
 */
import { Path, SVG } from '@gechiui/primitives';

const more = (
	<SVG viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
		<Path d="M4 9v1.5h16V9H4zm12 5.5h4V13h-4v1.5zm-6 0h4V13h-4v1.5zm-6 0h4V13H4v1.5z" />
	</SVG>
);

export default more;
